import { Collapse } from "common/Collapse";
import { aboutSFTPCollapseItems } from "./config";

export const AboutSFTPCollapse = () => {
  return <Collapse defaultCollapsed={["0"]} items={aboutSFTPCollapseItems} />;
};
